import "./style.scss";
import {
  ListBodyCell,
  ListBodyCellType,
} from "views/components/atoms/listCell";

export type ListBodyType = {
  type: ListBodyCellType;
  label?: React.ReactNode;
};

export type BodyShowList = ListBodyType[];

type ListBodyProps = {
  bodyShowList: BodyShowList;
  onClick?: (bodyShowList: BodyShowList) => void;
  onBlur?: () => void;
};

export const ListBody = (props: ListBodyProps) => {
  const { bodyShowList, onClick, onBlur } = props;

  const handleClick = () => {
    // ListBodyがクリックされたときに、onClickプロパティに渡されたクリックハンドラを呼び出す
    if (onClick) {
      onClick(bodyShowList);
    }
  };

  return (
    <div
      className="listBody"
      onClick={handleClick}
      onBlur={() => {
        console.log("onBlur");
      }}
      onFocus={() => {
        console.log("onFocus");
      }}
    >
      {bodyShowList.map((item, index) => {
        return <ListBodyCell key={index} type={item.type} label={item.label} />;
      })}
    </div>
  );
};
